// extracted by mini-css-extract-plugin
export default {"Overlay":"Navigation_Overlay__O+3DM","Navigation":"Navigation_Navigation__BN-kU","isOpen":"Navigation_isOpen__8EEe+"};